import _toArray from "../../toArray";
var exports = {};
const toArray = _toArray; // .files fallback, should be implemented in any browser

exports = function fallbackApi(dataTransfer) {
  const files = toArray(dataTransfer.files);
  return Promise.resolve(files);
};

export default exports;